import React from 'react';

function UserFill({ fill = 'rgb(143,144,164)', className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 30 30"
      fill={`${fill}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* User Head */}
      <circle cx="15" cy="10" r="5" stroke={fill} strokeWidth="2" />
      {/* User Body */}
      <path
        d="M5 26C5 21.5 9 18 15 18C21 18 25 21.5 25 26"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default UserFill;
